import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext } from 'react';
import { runAll, get } from '@elliemae/ds-utilities/utils';
import DropdownMenuContext from './DropdownMenuContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noop = function noop() {
  return null;
};

function MenuItemGroupSelectionHOC(WrappedComponent) {
  var handlerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'onSelect';
  return function (_ref) {
    var _ref$item = _ref.item,
        item = _ref$item === void 0 ? {} : _ref$item,
        restProps = _objectWithoutProperties(_ref, ["item"]);

    var _useContext = useContext(DropdownMenuContext),
        onItemClick = _useContext.onItemClick,
        selection = _useContext.selection;

    var propHandler = restProps[handlerName] || noop;

    var handler = _defineProperty({}, handlerName, function (active, itemOption) {
      return runAll(item.onSelect, onItemClick, propHandler)({
        item: itemOption,
        group: _objectSpread(_objectSpread({}, item), {}, {
          active: active
        })
      });
    });

    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, selection ? {
      active: get(selection, [item.id]) || item.active
    } : {}, handler));
  };
}

export default MenuItemGroupSelectionHOC;
//# sourceMappingURL=MenuItemGroupSelectionHOC.js.map
